module.exports = __webpack_public_path__ + "img/CGU.fb7df825.jpg";